@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (loonVanInternationaleOrganisatie.length > 0) {
      <div formArrayName="loonio">
        @for (item of loonVanInternationaleOrganisatie.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <div class="col-auto row" style="--bs-gutter-x: 0.5rem;" formGroupName="loon">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Internationale organisatie' : ''"
                                              class="col-auto custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Loon' : ''"
                                                [required]=true
                                                align="right"
                                                class="col-auto custom-input-150"
                                                formControlName="bedrag"
                                                id="bedrag"
                                                prefix="€"

              >
              </snelstart-ui-number-form-control>
            </div>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag premieloon' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="deelPremieloonVolksverzekeringen"
                                              id="deelPremieloonVolksverzekeringen"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-select-form-control [label]="i === 0 ? 'Zvw land' : ''"
                                              [options]="optionsZvw"
                                              [required]=true
                                              class="col-auto custom-input-150"
                                              formControlName="afdrachtZVWinNLmoetnog"

            >
            </snelstart-ui-select-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Btl loonheffing' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="loonheffing"
                                              id="buitenlandseLoonheffing"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-select-form-control [label]="i === 0 ? 'Soort' : ''"
                                              [options]="optionsTegenwoordig"
                                              [required]=true
                                              class="col-auto custom-input-250"
                                              formControlName="tegenwoordigeDienstbetrekking"

            >
            </snelstart-ui-select-form-control>
            <div class="col-auto">
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton' : ''"
                                   class="delete"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>

          </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                       type="link">Vrijgesteld loon toevoegen
  </snelstart-ui-button>
}
